import {
    CLUB_DELETE_START,
    CLUB_DELETE_SUCCESS,
    CLUB_DELETE_FAIL
} from "../constants/type";
import { cloneDeep } from "lodash";
const INITIAL_STATE = {
    isUserDeleteSuccess: false,
    successResponse: null,
    failedResponse: null
};

export default (state = INITIAL_STATE, action) => {
    let currentState = cloneDeep(state);
    switch (action.type) {
        case CLUB_DELETE_START:
            currentState.isUserDeleteSuccess = false;
            break;
        case CLUB_DELETE_SUCCESS:
            currentState.isUserDeleteSuccess = true;
            currentState.successResponse = action.payload;
            break;
        case CLUB_DELETE_FAIL:
            currentState.isUserDeleteSuccess = false;
            currentState.failedResponse = action.payload;
            break;
        default:
            return currentState;
    }
    return currentState;
};
